import lozad from "lozad";

export default class LazyLoad {
  constructor() {
    this.observer = lozad(".js-bg-lazy");
  }

  init() {
    this.observer.observe();
  }

  events() {
    // remove observer
  }
}



// WEBPACK FOOTER //
// ./scripts/components/lazyLoad.js